import modal from '@/utils/modal.js';

import LootCrateModal from './LootCrateModal.vue';

function showLootCrateRewards(lootCrateType, opts) {
  const m = modal.create(LootCrateModal, true, { persistent: false });
  m.body.classList.add('gmf-loot-crate-rewards');
  m.app.setLootCrateType(lootCrateType, opts.type);

  if (opts?.contents) {
    m.app.setContent(opts.contents);
    return;
  }

  if (opts.autoOpen) {
    m.app.open()
  }
}

export default showLootCrateRewards;